import React from "react";
import { Modal, Form, Input, Button, notification } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createVendor } from "../services/vendorsAPI";
import { useAuth } from "../hooks/useAuth";

const CreateVendorModal = ({ visible, onClose, handleSetVendor }) => {
  const { selectedProject } = useAuth();
  const projectId = selectedProject.project_id;
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const mutation = useMutation({
    mutationFn: createVendor,
    onSuccess: (response) => {
      queryClient.invalidateQueries(["vendors", projectId]);
      onClose();
      form.resetFields();
      if (handleSetVendor) {
        handleSetVendor(response._id);
      }
      notification.success({ message: "Vendor created successfully" });
    },
    onError: (error) => {
      notification.error({
        message: "Failed to create vendor",
        description: error.message,
      });
    },
  });

  const handleCreateVendor = (values) => {
    const vendorData = {
      ...values,
      project_id: projectId,
    };
    mutation.mutate(vendorData);
  };

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Create Vendor"
      open={visible}
      onCancel={handleClose}
      footer={null}
    >
      <Form form={form} onFinish={handleCreateVendor} layout="vertical">
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input the vendor name!" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="DBA" name="dba">
          <Input />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={mutation.isPending}
            style={{ width: "100%" }}
          >
            Create Vendor
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateVendorModal;
